// extracted by mini-css-extract-plugin
export var noSpinners = "_se-6";
export var percentageInput = "_se-7";
export var variantColor1 = "_se-0";
export var variantColor2 = "_se-1";
export var variantColor3 = "_se-2";
export var variantColor4 = "_se-3";
export var variantColor5 = "_se-4";
export var variantColor6 = "_se-5";